module.exports = __webpack_public_path__ + "img/gif2.gif.bak.e70ef88f.gif";